import { Variables } from 'graphql-request';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { getGraphqlRequestClient } from './clients';

export const useFetcher = <TData, TVariables extends Variables | undefined>(
  query: string,
  options?: RequestInit['headers'],
): ((variables?: TVariables) => Promise<TData>) => {
  const { getAccessTokenSilently } = useAuth0();

  const client = getGraphqlRequestClient(import.meta.env.VITE_GRAPHQL_URL, {
    headers: options,
  });

  return async (variables?: TVariables) => {
    const credentials = await getAccessTokenSilently();

    if (credentials && 'accessToken' in credentials) {
      client.setHeader('Authorization', `Bearer ${credentials?.accessToken}`);
    }

    if (credentials && 'status' in credentials && credentials.status === 'TOKEN_ERROR') {
      return Promise.reject(credentials);
    }
    return client.request(query, variables);
  };
};

export const hygraphRequest = (options?: RequestInit['headers']) => {
  return getGraphqlRequestClient(import.meta.env.VITE_HYGRAPH_URL, {
    headers: {
      ...options,
      Authorization: `Bearer ${import.meta.env.VITE_HYGRAPH_TOKEN}`,
    },
  });
};
